import BarraTitulo from '@/shared/components/ui/BarraTitulo'
export default {
    components: {
        BarraTitulo
    },
}